'use client'
import { Toaster } from "react-hot-toast";
import IntegrationsPanel from "../../components/integrations/IntegrationsPanel";

export const IntegrationsPage = () => {
	return (
		<div>
			<Toaster position="top-right" />
			<IntegrationsPanel />
		</div>
	);
};

